import React, { useRef, useEffect } from 'react';
import { Modal } from 'antd';
import style from './totemmodal.module.scss';

export default function SmallModal(props) {
  const { set, state } = props;
  const {REACT_APP_TOTEM_VIDEO_URL} = process.env; //eslint-disable-line

  const { container, iframe, totemText, textContainer } = style;
  const iframeRef = useRef(null);
  function closeModal() {
    set(!state);
    if (iframeRef.current) iframeRef.current.src = '';
  }

  useEffect(() => {
    if (state && iframeRef.current) {
      iframeRef.current.src = REACT_APP_TOTEM_VIDEO_URL;
    }
  }, [state]);

  return (
    <Modal
      bodyStyle={{ backgroundColor: '#f2f2f2', borderRadius: '20px' }}
      width={'80%'}
      visible={state}
      footer={null}
      onCancel={() => closeModal()}
    >
      <div className={container}>
        {REACT_APP_TOTEM_VIDEO_URL && <iframe
          height="50%"
          width="100%"
          style={{ borderRadius: '20px' }}
          ref={iframeRef}
          src={REACT_APP_TOTEM_VIDEO_URL}
          className={iframe}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>}
        <div className={textContainer}>
          <p className={totemText}>
          Droguería Suiza, una empresa familiar fundada en Abril de 1962, dedicada a la distribución de medicamentos, perfumería, dermocosmética, fragancias, maquillaje, etcétera, con un portfolio de más de 16000 productos.
Nuestra misión es brindar a nuestros clientes un servicio de calidad, para ello nos comprometimos a una inversión en tecnología innovadora, logrando eficiencia y confianza, y de esta manera fomentar el crecimiento sostenido de nuestros clientes. Contamos con personal comprometido con el mejoramiento continuo de procesos dinámicos, dedicados diariamente a la atención personalizada de nuestros clientes, con el fin de mantenerlos satisfechos.
          </p>
        </div>
      </div>
    </Modal>
  );
}
